import { render, staticRenderFns } from "./c-badge.vue?vue&type=template&id=3a6e8cc2&"
import script from "./c-badge.vue?vue&type=script&lang=js&"
export * from "./c-badge.vue?vue&type=script&lang=js&"
import style0 from "./c-badge.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports